import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { User } from '../../../../interfaces/auth.interface';
import { EditIconButton, DeleteIconButton } from '../../../../shared/components';

@Component({
  selector: 'colleague-table',
  standalone: true,
  imports: [CommonModule, MatIconModule, EditIconButton, DeleteIconButton],
  templateUrl: './colleague-table.component.html',
  styleUrl: './colleague-table.component.scss'
})
export class ColleagueTableComponent {
  @Input() colleagues: User[] = [];
  @Output() edit = new EventEmitter<User>();
  @Output() delete = new EventEmitter<number>();

  onEdit(colleague: User) {
    this.edit.emit(colleague);
  }

  onDelete(id: number) {
    this.delete.emit(id);
  }
}
